export default "__VITE_ASSET__CqIqNlYH__"